import apiRecipes from '../api/recipes';

let DefaultState = () => {
    return {
        Recipes: [],
        SpecificModals: [],
        SpecificLoading: false,
        NotFound: [],
        Pagination: {
            total: 0,
            current_page: 1,
            per_page: 20,
            last_page: 1,
        }
    };
};

export default {
    state: DefaultState(),
    getters: {
        Recipes_GetAll: state => () => {
            return state.Recipes;
        },
        Recipes_GetPagination: state => () => {
            return state.Pagination;
        },
        Recipes_GetByID: state => (RecipeID) => {
            return state.Recipes.find(R => R.id === RecipeID);
        },
        Recipes_GetBySlug: state => (RecipeSlug) => {
            return state.Recipes.find(R => R.slug === RecipeSlug);
        },
        Recipes_GetSpecificLoading: state => () => {
            return state.SpecificLoading;
        },
        Recipes_GetSpecificModals: state => () => {
            return state.SpecificModals;
        },
        Recipes_GetIsNotFoundByID: state => (RecipeID) => {
            return state.NotFound.indexOf(RecipeID) > -1;
        }
    },
    mutations: {
        RECIPES_RESET_STATE(state) {
            Object.assign(state, DefaultState());
        },
        RECIPES_ADD(state, Recipe) {
            state.Recipes.push(Recipe);
            state.SpecificLoading = false;
        },
        RECIPES_UPDATE(state, Recipe) {
            for (let x in state.Recipes) {
                if (state.Recipes[x].id === Recipe.id) {
                    state.Recipes[x] = Recipe;
                }
            }
        },
        RECIPES_REMOVE(state, RecipeID) {
            for (let x in state.Recipes) { if (state.Recipes[x].id === RecipeID) { state.Recipes.splice(x, 1); } }
        },
        RECIPES_UPDATE_ALL(state, Recipes) {
            state.Recipes = Recipes.data.map(Recipe => {
                return Recipe;
            });
            state.Pagination = {
                total: Recipes.total,
                current_page: Recipes.current_page,
                per_page: Recipes.per_page,
                last_page: Recipes.last_page,
            };
        },
        RECIPES_UPDATE_SPECIFIC_MODALS(state, Recipe) {
            if (typeof Recipe.id !== 'undefined') { state.SpecificModals.push(Recipe); }
            else { state.SpecificModals.pop(); }
            state.SpecificLoading = false;
        },
        RECIPES_ADD_NOT_FOUND(state, RecipeID) {
            if (state.NotFound.indexOf(RecipeID) < 0) { state.NotFound.push(RecipeID); }
            state.SpecificLoading = false;
        }
    },
    actions: {
        Recipes_ResetState({commit}) {
            commit('RECIPES_RESET_STATE');
        },
        Recipes_Add({commit}, Recipe) {
            commit('RECIPES_ADD', Recipe);
        },
        Recipes_Update({commit}, Recipe) {
            commit('RECIPES_UPDATE', Recipe);
        },
        Recipes_Remove({commit}, RecipeID) {
            apiRecipes.Delete(RecipeID).then(res => {
                if (res.status === 200) { commit('RECIPES_REMOVE', RecipeID); }
            });
        },
        Recipes_UpdateAll({commit}) {
            apiRecipes.Index().then(res => {
                if (typeof res.data.data !== 'undefined') { commit('RECIPES_UPDATE_ALL', res.data); }
            });
        },
        Recipes_GetByID({commit, state}, RecipeID) {
            if (typeof RecipeID === 'undefined' || state.SpecificLoading) { return true; }
            let Recipe = state.Recipes.find(R => R.id === RecipeID);
            if (typeof Recipe === 'undefined')
            {
                state.SpecificLoading = true;
                apiRecipes.Find(RecipeID).then(res => {
                    if (typeof res.data !== 'undefined') { commit('RECIPES_ADD', res.data); }
                }).catch(e => {
                    if (e.response.status === 404) { commit('RECIPES_ADD_NOT_FOUND', RecipeID); }
                });
            }
        },
        Recipes_GetBySlug({commit, state}, RecipeSlug) {
            if (typeof RecipeSlug === 'undefined' || state.SpecificLoading) { return true; }
            let Recipe = state.Recipes.find(R => R.slug === RecipeSlug);
            if (typeof Recipe === 'undefined')
            {
                state.SpecificLoading = true;
                apiRecipes.Find(RecipeSlug).then(res => {
                    if (typeof res.data !== 'undefined') { commit('RECIPES_ADD', res.data); }
                }).catch(e => {
                    if (e.response.status === 404) { commit('RECIPES_ADD_NOT_FOUND', RecipeSlug); }
                });
            }
        },
        Recipes_FindModal({commit, state}, RecipeID) {
            if (typeof RecipeID === 'undefined') { return commit('RECIPES_UPDATE_SPECIFIC_MODALS', {}); }
            let Recipe = state.Recipes.find(R => R.id === RecipeID);
            if (typeof Recipe !== 'undefined') { commit('RECIPES_UPDATE_SPECIFIC_MODALS', Recipe); }
            else
            {
                state.SpecificLoading = true;
                apiRecipes.Find(RecipeID).then(res => {
                    if (typeof res.data !== 'undefined')
                    {
                        commit('RECIPES_UPDATE_SPECIFIC_MODALS', res.data);
                        commit('RECIPES_ADD', res.data);
                    }
                });
            }
        },
        Recipes_Search({commit, state}, query) {
            apiRecipes.Index(query).then(res => {
                if (typeof res.data !== 'undefined') { commit('RECIPES_UPDATE_ALL', res.data); }
            });
        }
    }
};
